@if (!editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
      <div class="tw:w-auto tw:px-[15px]">
        <div class="kvp__k tw:py-1">Document Title:</div>
        <div class="kvp__k tw:py-1">Document Notes:</div>
      </div>
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="kvp__v tw:py-1">{{ timelineSection.documentTitle }} &nbsp;</div>
        <div class="kvp__v tw:py-1">{{ timelineSection.documentNotes }} &nbsp;</div>
      </div>
    </div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
      <div class="tw:w-full tw:px-[15px] tw:flex tw:justify-end" [ngClass]="{'tw:mb-4': viewDocument}">
        <button (click)="toggleDocument()" class="btn btn-outline-primary">{{ viewDocument ? 'Hide document' : 'Show document' }}</button>
      </div>
      @if (viewDocument && documentPreviewUrl) {
        <div class="tw:w-full tw:px-[15px]">
          <iframe [src]="documentPreviewUrl | safe" frameborder="0" allowfullscreen="true" class="responsive-iframe"></iframe>
        </div>
      }
    </div>
  </div>
}

@if (editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
      <div class="tw:w-1/2 tw:px-[15px]">
        <label class="field__label">Document Title:</label>
        <input
          class="field__control"
          type="text"
          [(ngModel)]="timelineSection.documentTitle"
          name="documentTitle"
          [disabled]="!isDocumentFormEditable()"
          />
        </div>
      </div>
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:w-full tw:px-[15px]">
          <label class="field__label">Document Notes:</label>
          <input
            class="field__control"
            type="text"
            [(ngModel)]="timelineSection.documentNotes"
            name="documentNotes"
            [disabled]="!isDocumentFormEditable()"
            maxlength="3000" />
          <span class="field__hint tw:block tw:text-right">{{timelineSection.documentNotes?.length || 0}}/3000</span>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
          @if (showMarkForDeletionButton()) {
            <div class="tw:flex-1 tw:px-[15px]">
              <label class="field__checkbox"><input type="checkbox"
                [(ngModel)]="timelineSection.deleteDocument" [ngModelOptions]="{standalone: true}"
                [disabled]="!isDocumentFormEditable()" /> Mark for deletion</label>
            </div>
          }
        </div>
        @if (timelineSection.documentUrl && documentPreviewUrl) {
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
            <div class="tw:flex-1 tw:px-[15px]">
              <iframe [src]="documentPreviewUrl | safe" frameborder="0" allowfullscreen="true" class="responsive-iframe"></iframe>
            </div>
          </div>
        }
        @if (!timelineSection.documentUrl) {
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
            <div class="file-selector-container">
              <div>
                <mat-toolbar>
                  <input
                    [(ngModel)]="fileAttr"
                    readonly
                    name="name"
                    class="file-select-text field__control"
                    />
                    <button
                      mat-flat-button
                      class="btn btn-primary"
                      style="z-index: 10"
                      (click)="fileInput.click()"
                      [disabled]="!isDocumentFormEditable()"
                      >
                      Browse File
                    </button>
                  </mat-toolbar>
                  <input
                    type="file"
                    #fileInput
                    id="uploadFile"
                    (change)="uploadFileEvt($event)"
                    name="uploadFile"
                    multiple="false"
                    accept=".pdf"
                    />
                  </div>
                </div>
              </div>
            }
          </div>
        }
